import { gql } from '@lcs/shared/api';
export const SaveBlockedPhoneNumberMutation = gql`
   mutation SaveBlockedPhoneNumber($blockedPhoneNumber: BlockedPhoneNumberInput!) {
      blockedPhoneNumber: saveBlockedPhoneNumber(blockedPhoneNumber: $blockedPhoneNumber) {
         accountId
         blockedPhoneNumberId
         phoneNumber
         comment
      }
   }
`;
